// extracted by mini-css-extract-plugin
export default {"box":"index_box_SFbE7","hongbaoBox":"index_hongbaoBox_0gNBf","close":"index_close_SqYwz","image":"index_image_14sqC","tada":"index_tada_rCSY0"};